import { RadarChartPoint, VerticalBarSeriesPoint } from 'react-vis';
import {
    AffinityClusterObservationStatsDto,
    DashboardObservationStatsDto,
} from '../../generated_client';
import ObservationTypes from '../../utils/ObservationTypes';
export default class ObservationStatsLogic {
    public getColor(observationType: string) {
        switch (observationType) {
            case ObservationTypes.Rose:
                return 'plum';
            case ObservationTypes.Bud:
                return 'limegreen';
            case ObservationTypes.Thorn:
                return 'cornflowerblue';
            default:
                return 'black';
        }
    }

    public getObservationRadialDataPoints(dashboardStats: DashboardObservationStatsDto) {
        const totalObservations = this.getTotalObservations(dashboardStats);
        return dashboardStats
            .observationStats!.sort((a, b) => {
                return a.observationType!.localeCompare(b.observationType!);
            })
            .map((x) => {
                return {
                    angle: (x.numObservations! / totalObservations) * 360,
                    color: this.getColor(x.observationType!),
                    label: `${x.numObservations!} ${x.observationType}(s)`,
                } as RadarChartPoint;
            });
    }

    public getTotalObservations(dashboardStats: DashboardObservationStatsDto) {
        let totalObservations = 0;
        dashboardStats.observationStats!.forEach((x) => (totalObservations += x.numObservations!));

        return totalObservations;
    }

    public getAffinityClusterBarDataPoints(
        affinityClusterStats: AffinityClusterObservationStatsDto[]
    ) {
        const data = [] as VerticalBarSeriesPoint[][];
        affinityClusterStats.forEach((x) => {
            if (x.observationStats!.length > 0) {
                data.push(
                    x
                        .observationStats!.sort((a, b) => {
                            return a.observationType!.localeCompare(b.observationType!);
                        })
                        .map((y) => {
                            return {
                                color: this.getColor(y.observationType!),
                                x: x.affinityClusterName,
                                y: y.numObservations,
                            } as VerticalBarSeriesPoint;
                        })
                );
            } else {
                data.push([{ x: x.affinityClusterName, y: 0 } as VerticalBarSeriesPoint]);
            }
        });
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/dashboardRows/ObservationStats/ObservationStatsLogic.ts